const defaultState = {
  config: null,
  stakeholders: [],
  calculations: null,
  loading: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'FETCH_REVENUE_CONFIG_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_REVENUE_CONFIG_SUCCESS':
      return { ...state, loading: false, config: action.payload };
    case 'FETCH_REVENUE_CONFIG_FAILURE':
      return { ...state, loading: false, error: action.error };

    case 'UPDATE_REVENUE_CONFIG_REQUEST':
      return { ...state, loading: true, error: null };
    case 'UPDATE_REVENUE_CONFIG_SUCCESS':
      return { ...state, loading: false, config: action.payload };
    case 'UPDATE_REVENUE_CONFIG_FAILURE':
      return { ...state, loading: false, error: action.error };

    case 'FETCH_STAKEHOLDERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_STAKEHOLDERS_SUCCESS':
      return { ...state, loading: false, stakeholders: action.payload };
    case 'FETCH_STAKEHOLDERS_FAILURE':
      return { ...state, loading: false, error: action.error };

    case 'UPDATE_STAKEHOLDERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'UPDATE_STAKEHOLDERS_SUCCESS':
      return { ...state, loading: false, stakeholders: action.payload };
    case 'UPDATE_STAKEHOLDERS_FAILURE':
      return { ...state, loading: false, error: action.error };

    case 'CALCULATE_REVENUE_REQUEST':
      return { ...state, loading: true, error: null };
    case 'CALCULATE_REVENUE_SUCCESS':
      return { ...state, loading: false, calculations: action.payload };
    case 'CALCULATE_REVENUE_FAILURE':
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
}; 